import { useState } from 'react';
import { faqData } from '@/mocks/faq';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <SchemaOrg
        type="FAQPage"
        faqData={faqData.map((f) => ({ question: f.question, answer: f.answer }))}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于韩漫之家，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
              >
                <h4 className="font-heading font-semibold text-foreground-900 text-sm md:text-base pr-4">
                  {faq.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openId === faq.id ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'pb-4 md:pb-5 max-h-96' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}